export class DocumentTemplate {
  public id: number;
  public type: string;
  public serviceId?: number;
  public description?: string;
  public typeAccuseDeReception: boolean;
  public typeFicheIdentification: boolean;
  public nePasGenererDePdf: boolean;
  public utilisableParContactId?: number;
  public private: boolean;
  public public: boolean;
  public langueId?: number;
  public policeFigee?: string;
  public policeTaille?: number;
  public typePv: boolean;
  public categoryId?: number;
  public classementId?: number;
  public sourceId?: number;
  public rtf?: string;
  public procedureValidationASuivre: number;
  public hasProcedure = false;
  public nePasProposerEdition?: boolean;
  public nePasproposerRenommer?: boolean;
  public nePasProposerImprimer?: boolean;
  public signBySignataire?: boolean;

  // Fields for service
  public serviceDescription?: string;
  public pastellCircuitId: number;
  public editeurSourceType: string;
  constructor(data?: DocumentTemplate) {
    Object.assign(this, data);
    if (this.procedureValidationASuivre) {
      this.hasProcedure = true;
    } else {
      this.hasProcedure = false;
    }
  }
}

export class ValidationCSSignatureDTO {
  id: number;
  validationId: number;
  ordre: number;
  serviceId: number;
  serviceRelatif: number;
  roleId: number;
  questionPosee: string;
}

export interface DocumentFusionFieldsDTO {
  baseInfos: [
    {
      key: string;
      description: string;
    },
  ];
  expediteur: [
    {
      key: string;
      description: string;
    },
  ];
  destinataires: [
    {
      key: string;
      description: string;
    },
  ];
  publipostage: [
    {
      key: string;
      description: string;
    },
  ];
  serviceEmailSignature: [
    {
      key: string;
      description: string;
    },
  ];
  natureCustomFields: [
    {
      key: string;
      description: string;
    },
  ];
}
